import React from 'react';
import { Modal, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import ProviderStore from 'store/Provider';
import { getUrlParam } from 'utils/common';
import { PATH } from 'constants/path';
import CommonStore from 'store/Common';

const RedirectPage = () => {
    const navigate = useNavigate();
    const email = getUrlParam('email');
    const code = getUrlParam('code');

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [showModal, setShowModal] = React.useState(false);

    React.useEffect(() => {
        navigate(PATH.PPA_RESET_PASSWORD, { state: { email, code } });
    }, []);
    return (
        <div style={{ minHeight: '300', textAlign: 'center', lineHeight: '300px' }}>
            <Spin spinning />
            <Modal
                open={showModal}
            >
                <div>{code}</div>
            </Modal>
        </div>
    );
};
export default RedirectPage;
